const ShareLeaderboardGroups = [
  // {
  //   Slug: 'original-mahjongg-solitaire',
  //   GroupSlug: 'mahjongg-solitaire'
  // },
  // {
  //   Slug: "fluzone-klondike-solitaire",
  //   GroupSlug: "klondike-solitaire",
  // },
  // {
  //   Slug: 'sponsored-classic-solitaire',
  //   GroupSlug: 'classic-solitaire'
  // },
  // {
  //  Slug: 'original-mahjongg-dimensions',
  //  GroupSlug: 'mahjongg-dimensions'
  // },
  //{
  // Slug: 'aarp-exxonmobil-block-champ',
  // GroupSlug: 'block-champ'
  //},
  // {
  //   Slug: 'original-block-champ',
  //   GroupSlug: 'block-champ'
  // },
  // {
  //   Slug: "preservision-klondike-solitaire",
  //   GroupSlug: "klondike-solitaire",
  // },
  {
    Slug: "aarp-sister-word-search",
    GroupSlug: "daily-word-search",
  },
  {
    Slug: "mahjongg-dimensions-2023",
    GroupSlug: "mahjongg-dimensions",
  },
  // {
  //   Slug: "quaker-oats-klondike-solitaire",
  //   GroupSlug: "classic-solitaire",
  // },
  {
    Slug: "outspell-clean",
    GroupSlug: "outspell",
  },
];

export const getGroupSlugByGame = (slug: string) => {
  const found = ShareLeaderboardGroups.find((item) => item.Slug === slug);
  return found ? found.GroupSlug : slug;
};
